module.exports = __webpack_public_path__ + "static/media/scape-admin-delete-icon.3a9138b7.svg";